import React, { useRef, ChangeEvent } from 'react';
import Icon from 'components/atoms/Icon';

interface AttachButtonProps {
  onFileSelect: (files: File[]) => void;
  acceptedTypes?: string;
  helperText?: string;
  multiple?: boolean;
  className?: string;
}

const AttachButton: React.FC<AttachButtonProps> = ({
  onFileSelect,
  acceptedTypes = '.png,.pdf,.xml,.jpg,.jpeg',
  helperText = 'Upload files in PNG, JPG, PDF, or XML format.',
  multiple = true,
  className = ''
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = (): void => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      onFileSelect(files);
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <button
        type="button"
        className="flex items-center gap-1.5 px-3 py-2 text-gray-500 hover:bg-gray-50 hover:text-gray-700 rounded-md text-[12px] transition-colors"
        onClick={handleClick}
        aria-label="Attach files"
      >
        <Icon name="attach" className="w-4 h-4" />
        <span>Attach</span>
      </button>

      <input
        ref={fileInputRef}
        type="file"
        accept={acceptedTypes}
        multiple={multiple}
        onChange={handleFileChange}
        className="hidden"
      />

      {helperText && (
        <span className="text-[10px] text-gray-400">{helperText}</span>
      )}
    </div>
  );
};

export default AttachButton;
